function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { INLINES, BLOCKS } from '@contentful/rich-text-types';
import styled from 'styled-components';
import { Icon } from '@cbhq/cds-web/icons/Icon';
import { spacing } from '@cbhq/cds-web/tokens';
import { ANALYTICS_KEY } from '../../../constants.js';
import '../../Div/index.js';
import { Text } from '../../Text.js';
import { Heading } from '../components/Heading.js';
import { InlineHyperLink } from '../components/InlineHyperLink.js';
import { composeRichTextComponents } from './composeRichTextComponents.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Div } from '../../Div/Div.js';
const createListRichTextOptions = (listStyle, iconColor = 'primary') => composeRichTextComponents({
  customRenderOptions: {
    [INLINES.HYPERLINK]: props => InlineHyperLink(_objectSpread({
      dataQa: ANALYTICS_KEY.LabelRichText
    }, props)),
    [BLOCKS.PARAGRAPH]: props => (node, children) => {
      return /*#__PURE__*/jsx(Text, {
        as: "p",
        display: "block",
        color: props?.color,
        spacingTop: {
          sm: 1,
          lg: 2
        },
        variant: {
          sm: 'label2',
          lg: 'body'
        },
        children: /*#__PURE__*/jsx(BreakSpaces, {
          children: children
        })
      });
    },
    [BLOCKS.HEADING_2]: props => Heading(_objectSpread(_objectSpread({
      as: 'h2'
    }, props), {}, {
      color: props?.secondaryColor
    })),
    [BLOCKS.UL_LIST]: () => (node, children) => {
      return /*#__PURE__*/jsx(StyledList, {
        children: children
      });
    },
    [BLOCKS.LIST_ITEM]: props => (node, children) => {
      return /*#__PURE__*/jsx(StyledLi, {
        as: "li",
        color: props?.color,
        $hasCustomIcon: !!listStyle,
        children: listStyle ? /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx(Div, {
            position: "absolute",
            spacingTop: {
              sm: 0.5,
              lg: 2
            },
            children: /*#__PURE__*/jsx(Icon, {
              name: listStyle,
              color: iconColor,
              size: "m"
            })
          }), children]
        }) : children
      });
    }
  }
});
const BreakSpaces = styled.span`
  white-space: break-spaces;
`;
const StyledLi = styled(Div)`
  position: relative;
  display: list-item;
  list-style: disc;

  ${({
  $hasCustomIcon
}) => $hasCustomIcon && `
    list-style: none;
    p {
      margin-left: ${spacing[5]};
     }
  `};
`;
const StyledList = styled.ul`
  padding-inline-start: ${spacing[2]};
`;
export { createListRichTextOptions };
//# sourceMappingURL=listRichTextOptions.js.map
